import { Box, Column, Columns } from 'braid-design-system';
import React, { type FunctionComponent, type ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

const PageAlertMessage: FunctionComponent<Props> = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <Box marginBottom="large" marginTop="large">
      <Columns space="large" collapseBelow="tablet">
        <Column width="2/3">{children}</Column>
      </Columns>
    </Box>
  );
};

export default PageAlertMessage;
